module.exports = __webpack_public_path__ + "media/mosaics/Mosaics-WhoItsFor-Grandparents-80130a01.jpg";